// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-size: 1em;
  height: 100%;
}

h3 {
  font-family: Lato;
  text-align: center;
  color: #0080ff;
}

.accordion {
  width: 100%;
  padding: 0;
  max-width: 350px;
  margin: 10px;
  list-style: none;
}

.accordion .menu {
  position: relative;
  padding: 15px 15px 15px 15px;
  color: #4d4d4d;
  font-weight: bold;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.4s ease;
  margin-bottom: 2px;
}

.accordion li:last-child .menu {
  border-bottom: 0;
}

.accordion li ion-icon.fa-chevron-down {
  position: relative;
  color: red;
  left: 1%;
}

.accordion li.active ion-icon.fa-chevron-down {
  transform: rotate(180deg);
}

.submenu {
  height: 0;
  overflow: hidden;
  background: #ffffff;
  font-size: 14px;
  transition: height 0.4s ease;
}

.submenu li {
  border-bottom: 1px solid #4b4a5e;
}

.accordion li:last-child .submenu {
  border-radius: 0 0 4px 4px;
}

.accordion li:last-child .submenu li:last-child {
  border-bottom: 0;
}

.circles {
  height: 26px;
  width: 26px;
  border: 2px solid silver;
  border-radius: 20%;
  display: inline-block;
}

.circle-desc {
  position: absolute;
  top: 2.2rem;
  font-size: 12px;
  width: auto;
  max-width: 9.375em;
  margin-left: -0.75em;
}

.circle-active {
  background-color: #f11a1a;
  border: 2px solid red;
}

.circle-desc-active {
  font-weight: bold;
}

.bar {
  width: 8%;
  height: 5px;
  margin-bottom: 10px;
  border: 0.031em solid silver;
  color: silver;
  background-color: silver;
  display: inline-block;
  text-align: center;
  margin: "0 auto";
}

.bar-active {
  width: 8%;
  height: 5px;
  margin-bottom: 10px;
  border: 0.031em solid red;
  color: red;
  background-color: red;
  display: inline-block;
  text-align: center;
  margin: "0 auto";
}

.container {
  min-width: 320px;
  margin: "0px auto";
  text-align: center;
}

.circle-desc {
  position: relative;
  top: 2.2rem;
  font-size: 12px;
  width: auto;
  max-width: 9.375em;
  margin-left: -0.75em;
}

@media only screen and (max-width: 320px) {
  body {
    font-size: 20%;
  }
}
/*extra small devices*/
@media only screen and (max-width: 600px) {
  body {
    font-size: 40%;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  body {
    font-size: 60%;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  body {
    font-size: 80%;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  body {
    font-size: 100%;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  body {
    font-size: 120%;
  }
}
.multi-steps > li.is-active ~ li:before, .multi-steps > li.is-active:before, .multi-steps > li:before {
  content: counter(stepNum);
  font-family: inherit;
  font-weight: 700;
}
.multi-steps > li.is-active ~ li:after, .multi-steps > li.is-active:after {
  background-color: pink;
}

.multi-steps {
  display: table;
  table-layout: fixed;
  width: 50%;
}
.multi-steps > li {
  counter-increment: stepNum;
  text-align: center;
  display: table-cell;
  position: relative;
  color: silver;
}
.multi-steps > li:before {
  display: block;
  margin: 0 auto 4px;
  background-color: yellow;
  width: 36px;
  height: 36px;
  line-height: 32px;
  text-align: center;
  font-weight: bold;
  border-width: 4px;
  border-style: solid;
  border-color: yellow;
  border-radius: 15%;
}
.multi-steps > li:after {
  content: "";
  height: 4px;
  width: 100%;
  background-color: pink;
  position: absolute;
  top: 16px;
  left: 50%;
  z-index: -1;
}
.multi-steps > li:last-child:after {
  display: none;
}
.multi-steps > li.is-active:before {
  background-color: red;
  border-color: red;
}
.multi-steps > li.is-active ~ li {
  color: silver;
}
.multi-steps > li.is-active ~ li:before {
  background-color: yellow;
  border-color: yellow;
}
.multi-steps > li.is-active:after {
  content: "";
  height: 4px;
  width: 100%;
  background-color: red;
  position: absolute;
  top: 16px;
  left: 50%;
  z-index: -1;
}

/*Form Wizard*/
.bs-wizard {
  border-bottom: solid 1px #e0e0e0;
  padding: 0 0 10px 0;
}

.bs-wizard > .bs-wizard-step {
  padding: 0;
  position: relative;
}

.bs-wizard > .bs-wizard-step .bs-wizard-stepnum {
  color: #595959;
  font-size: 16px;
  margin-bottom: 5px;
}

.bs-wizard > .bs-wizard-step .bs-wizard-info {
  color: #999;
  font-size: 14px;
}

.bs-wizard > .bs-wizard-step > .bs-wizard-dot {
  position: absolute;
  width: 30px;
  height: 30px;
  display: block;
  background: #595959;
  top: 45px;
  left: 50%;
  margin-top: -15px;
  margin-left: -15px;
  border-radius: 25%;
  color: white;
  font-weight: bold;
  text-align: center;
  padding-top: 3px;
}

/*.bs-wizard > .bs-wizard-step > .bs-wizard-dot:after {content: ' '; width: 14px; height: 14px; background: #669d2c; border-radius: 50px; position: absolute; top: 8px; left: 8px; }  */
.bs-wizard > .bs-wizard-step > .progress {
  position: relative;
  border-radius: 0px;
  height: 8px;
  box-shadow: none;
  margin: 20px 0;
}

.bs-wizard > .bs-wizard-step > .progress > .progress-bar {
  width: 0px;
  box-shadow: none;
  background: #fc0d20;
}

.bs-wizard > .bs-wizard-step.complete > .progress > .progress-bar {
  width: 100%;
}

.bs-wizard > .bs-wizard-step.active > .progress > .progress-bar {
  width: 50%;
}

.bs-wizard > .bs-wizard-step:first-child.active > .progress > .progress-bar {
  width: 0%;
}

.bs-wizard > .bs-wizard-step:last-child.active > .progress > .progress-bar {
  width: 100%;
}

.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot {
  background-color: #595959;
}

.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot:after {
  opacity: 0;
}

.bs-wizard > .bs-wizard-step:first-child > .progress {
  left: 50%;
  width: 50%;
}

.bs-wizard > .bs-wizard-step:last-child > .progress {
  width: 50%;
}

.bs-wizard > .bs-wizard-step.disabled a.bs-wizard-dot {
  pointer-events: none;
}

/*END Form Wizard*/`, "",{"version":3,"sources":["webpack://./src/app/widgets/mi-accordion/mi-accordion.component.scss"],"names":[],"mappings":"AAAA;EACG,cAAA;EACC,YAAA;AACJ;;AAEC;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;AACH;;AAGC;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAAH;;AAGC;EACE,kBAAA;EACA,4BAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAAH;;AAGC;EACE,gBAAA;AAAH;;AAKC;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAFH;;AAMC;EACE,yBAAA;AAHH;;AAQC;EACE,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AALH;;AAQC;EACE,gCAAA;AALH;;AAQC;EACE,0BAAA;AALH;;AAQC;EACE,gBAAA;AALH;;AAWC;EACE,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;AARH;;AAaC;EACC,kBAAA;EACA,WAAA;EACD,eAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AAVD;;AAaC;EACI,yBAAA;EACA,qBAAA;AAVL;;AAaC;EACA,iBAAA;AAVD;;AAcC;EACE,SAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAXH;;AAeC;EACE,SAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAZH;;AAcC;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AAXH;;AAcC;EACE,kBAAA;EACA,WAAA;EACD,eAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AAXF;;AAcC;EACG;IACE,cAAA;EAXJ;AACF;AAcC,sBAAA;AACA;EACG;IACE,cAAA;EAZJ;AACF;AAeC,oEAAA;AACA;EACG;IACE,cAAA;EAbJ;AACF;AAgBC,qDAAA;AACA;EACE;IACG,cAAA;EAdJ;AACF;AAiBC,mDAAA;AACA;EACE;IACG,eAAA;EAfJ;AACF;AAkBC,oEAAA;AACA;EACG;IACE,eAAA;EAhBJ;AACF;AAwBG;EACE,yBAAA;EACA,oBAAA;EACA,gBAAA;AAtBL;AAwBG;EACE,sBAAA;AAtBL;;AAyBC;EACE,cAAA;EACA,mBAAA;EACA,UAAA;AAtBH;AAuBG;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAtBY;AACjB;AAuBK;EAEE,cAAA;EACA,kBAAA;EACA,wBAAA;EAEA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EAEE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAxBT;AA2BK;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;AAzBP;AA6BO;EACE,aAAA;AA3BT;AAiCO;EACE,qBAAA;EACA,iBAAA;AA/BT;AAkCO;EACE,aAnEQ;AAmCjB;AAkCS;EACE,wBAAA;EACA,oBAAA;AAhCX;AAmCO;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;AAjCP;;AAwCC,cAAA;AACD;EAAY,gCAAA;EAAkC,mBAAA;AAnC9C;;AAoCA;EAA8B,UAAA;EAAY,kBAAA;AA/B1C;;AAiCA;EAAiD,cAAA;EAAgB,eAAA;EAAiB,kBAAA;AA3BlF;;AA4BA;EAA8C,WAAA;EAAa,eAAA;AAvB3D;;AAwBA;EAA+C,kBAAA;EAAoB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,mBAAA;EAAqB,SAAA;EAAW,SAAA;EAAW,iBAAA;EAAmB,kBAAA;EAAoB,kBAAA;EAAmB,YAAA;EAAa,iBAAA;EAAkB,kBAAA;EAAmB,gBAAA;AAPrQ;;AAQA,uLAAA;AACA;EAA0C,kBAAA;EAAoB,kBAAA;EAAoB,WAAA;EAAa,gBAAA;EAAkB,cAAA;AAAjH;;AACA;EAA0D,UAAA;EAAW,gBAAA;EAAkB,mBAAA;AAKvF;;AAJA;EAAmE,WAAA;AAQnE;;AAPA;EAAiE,UAAA;AAWjE;;AAVA;EAA6E,SAAA;AAc7E;;AAbA;EAA4E,WAAA;AAiB5E;;AAhBA;EAAwD,yBAAA;AAoBxD;;AAnBA;EAA8D,UAAA;AAuB9D;;AAtBA;EAAuD,SAAA;EAAW,UAAA;AA2BlE;;AA1BA;EAAsD,UAAA;AA8BtD;;AA7BA;EAAuD,oBAAA;AAiCvD;;AAhCA,kBAAA","sourcesContent":["body{\r\n   font-size:1em;\r\n    height: 100%;\r\n }\r\n \r\n h3 {\r\n   font-family: Lato;\r\n   text-align: center;\r\n   color:\t#0080ff;\r\n }\r\n\r\n\r\n .accordion {\r\n   width: 100%;\r\n   padding: 0;\r\n   max-width: 350px;\r\n   margin: 10px;\r\n   list-style: none;\r\n }\r\n \r\n .accordion .menu {\r\n   position: relative;\r\n   padding: 15px 15px 15px 15px;\r\n   color: #4d4d4d;\r\n   font-weight: bold;\r\n   border: 1px solid #ccc;\r\n   border-radius: 4px;\r\n   cursor: pointer;\r\n   transition: all 0.4s ease;\r\n   margin-bottom: 2px;\r\n }\r\n \r\n .accordion li:last-child .menu {\r\n   border-bottom: 0;\r\n }\r\n \r\n \r\n \r\n .accordion li ion-icon.fa-chevron-down {\r\n   position: relative;\r\n   color: red;\r\n   left: 1%;\r\n   \r\n }\r\n \r\n .accordion li.active ion-icon.fa-chevron-down {\r\n   transform: rotate(180deg);\r\n }\r\n\r\n \r\n\r\n .submenu {\r\n   height: 0;\r\n   overflow: hidden;\r\n   background: #ffffff;\r\n   font-size: 14px;\r\n   transition: height 0.4s ease;\r\n }\r\n \r\n .submenu li {\r\n   border-bottom: 1px solid #4b4a5e;\r\n }\r\n \r\n .accordion li:last-child .submenu {\r\n   border-radius: 0 0 4px 4px;\r\n }\r\n \r\n .accordion li:last-child .submenu li:last-child {\r\n   border-bottom: 0;\r\n }\r\n \r\n\r\n \r\n\r\n .circles{\r\n   height:26px;\r\n   width: 26px;\r\n   border: 2px solid silver; \r\n   border-radius: 20%;\r\n   display: inline-block;\r\n\r\n  \r\n }\r\n\r\n .circle-desc{\r\n  position: absolute;\r\n  top: 2.2rem;\r\n font-size: 12px;\r\n width: auto;\r\n max-width:9.375em;\r\n margin-left:-0.750em;\r\n}\r\n \r\n .circle-active{\r\n     background-color:#f11a1a;\r\n     border: 2px solid red; \r\n }\r\n \r\n .circle-desc-active{\r\n font-weight: bold;\r\n \r\n }\r\n \r\n .bar{\r\n   width: 8%;\r\n   height: 5px;\r\n   margin-bottom:10px;\r\n   border: 0.031em solid silver;\r\n   color:silver;\r\n   background-color:silver;;\r\n   display: inline-block;\r\n   text-align:center;\r\n   margin:\"0 auto\";\r\n }\r\n \r\n \r\n .bar-active{\r\n   width: 8%;\r\n   height: 5px;\r\n   margin-bottom:10px;\r\n   border: 0.031em solid red;\r\n   color:red;\r\n   background-color:red;;\r\n   display: inline-block;\r\n   text-align:center;\r\n   margin:\"0 auto\";\r\n }\r\n .container{\r\n   min-width:320px;\r\n   margin: \"0px auto\";\r\n   text-align: center;\r\n }\r\n \r\n .circle-desc{\r\n   position: relative;\r\n   top: 2.2rem;\r\n  font-size: 12px;\r\n  width: auto;\r\n  max-width:9.375em;\r\n  margin-left:-0.750em;\r\n }\r\n \r\n @media only screen and (max-width: 320px){\r\n    body {\r\n      font-size:20%\r\n   }\r\n } \r\n \r\n /*extra small devices*/\r\n @media only screen and (max-width: 600px){\r\n    body {\r\n      font-size:40%\r\n   }\r\n } \r\n \r\n /* Small devices (portrait tablets and large phones, 600px and up) */\r\n @media only screen and (min-width: 600px) {\r\n    body {\r\n      font-size:60%\r\n   }\r\n } \r\n \r\n /* Medium devices (landscape tablets, 768px and up) */\r\n @media only screen and (min-width: 768px) {\r\n   body {\r\n      font-size:80%\r\n   }\r\n } \r\n \r\n /* Large devices (laptops/desktops, 992px and up) */\r\n @media only screen and (min-width: 992px) {\r\n   body {\r\n      font-size:100%\r\n   }\r\n } \r\n \r\n /* Extra large devices (large laptops and desktops, 1200px and up) */\r\n @media only screen and (min-width: 1200px) {\r\n    body {\r\n      font-size:120%\r\n   }\r\n }\r\n \r\n\r\n $brand-primary: silver;\r\n $white: #fff;\r\n $grey-light: #ededed;\r\n %remain-steps{\r\n   &:before {\r\n     content: counter(stepNum);\r\n     font-family: inherit;\r\n     font-weight: 700;\r\n   }\r\n   &:after{\r\n     background-color: pink;\r\n   }\r\n }\r\n .multi-steps{\r\n   display: table;\r\n   table-layout: fixed;\r\n   width: 50%;\r\n   > li{\r\n     counter-increment: stepNum;\r\n     text-align: center;\r\n     display: table-cell;\r\n     position: relative;\r\n     color: $brand-primary;\r\n \r\n     &:before{\r\n       @extend %remain-steps;\r\n       display: block;\r\n       margin: 0 auto 4px;\r\n       background-color: yellow;\r\n       \r\n       width: 36px;\r\n       height: 36px;\r\n       line-height: 32px;\r\n       text-align: center;\r\n       font-weight: bold;\r\n       border:{\r\n         width: 4px;\r\n         style: solid;\r\n         color: yellow;\r\n         radius: 15%;\r\n       }\r\n     }\r\n     &:after{\r\n       content: '';\r\n       height: 4px;\r\n       width: 100%;\r\n       background-color: pink;\r\n       position: absolute;\r\n       top: 16px;\r\n       left: 50%;\r\n       z-index: -1;\r\n     }\r\n     \r\n     &:last-child{\r\n       &:after{\r\n         display: none;\r\n       }\r\n     }\r\n \r\n     &.is-active{\r\n       @extend %remain-steps;\r\n       &:before{\r\n         background-color: red;\r\n         border-color: red;\r\n       }\r\n \r\n       ~ li{\r\n         color:$brand-primary;;\r\n         @extend %remain-steps;\r\n         &:before{\r\n           background-color: yellow;\r\n           border-color: yellow;\r\n         }\r\n       }\r\n       &:after{\r\n       content: '';\r\n       height: 4px;\r\n       width: 100%;\r\n       background-color: red;\r\n       position: absolute;\r\n       top: 16px;\r\n       left: 50%;\r\n       z-index: -1;\r\n     }\r\n     }\r\n   }\r\n }\r\n\r\n\r\n /*Form Wizard*/\r\n.bs-wizard {border-bottom: solid 1px #e0e0e0; padding: 0 0 10px 0;}\r\n.bs-wizard > .bs-wizard-step {padding: 0; position: relative;}\r\n.bs-wizard > .bs-wizard-step + .bs-wizard-step {}\r\n.bs-wizard > .bs-wizard-step .bs-wizard-stepnum {color: #595959; font-size: 16px; margin-bottom: 5px;}\r\n.bs-wizard > .bs-wizard-step .bs-wizard-info {color: #999; font-size: 14px;}\r\n.bs-wizard > .bs-wizard-step > .bs-wizard-dot {position: absolute; width: 30px; height: 30px; display: block; background: #595959; top: 45px; left: 50%; margin-top: -15px; margin-left: -15px; border-radius: 25%;color: white;font-weight: bold;text-align: center;padding-top: 3px;} \r\n/*.bs-wizard > .bs-wizard-step > .bs-wizard-dot:after {content: ' '; width: 14px; height: 14px; background: #669d2c; border-radius: 50px; position: absolute; top: 8px; left: 8px; }  */\r\n.bs-wizard > .bs-wizard-step > .progress {position: relative; border-radius: 0px; height: 8px; box-shadow: none; margin: 20px 0;}\r\n.bs-wizard > .bs-wizard-step > .progress > .progress-bar {width:0px; box-shadow: none; background: #fc0d20;}\r\n.bs-wizard > .bs-wizard-step.complete > .progress > .progress-bar {width:100%;}\r\n.bs-wizard > .bs-wizard-step.active > .progress > .progress-bar {width:50%;}\r\n.bs-wizard > .bs-wizard-step:first-child.active > .progress > .progress-bar {width:0%;}\r\n.bs-wizard > .bs-wizard-step:last-child.active > .progress > .progress-bar {width: 100%;}\r\n.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot {background-color: #595959;}\r\n.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot:after {opacity: 0;}\r\n.bs-wizard > .bs-wizard-step:first-child  > .progress {left: 50%; width: 50%;}\r\n.bs-wizard > .bs-wizard-step:last-child  > .progress {width: 50%;}\r\n.bs-wizard > .bs-wizard-step.disabled a.bs-wizard-dot{ pointer-events: none; }\r\n/*END Form Wizard*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
